<template>
  <TemplateDbsDetail v-if="isReadyToDraw" :park="park" />

  <DialogInitialLoading v-else />
</template>

<script>
import { onMounted, computed, watch, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import API from "@/API";
import TemplateDbsDetail from "@/views/Templates/Dbs/TemplateDbsDetail";
import dbsService from "@/services/dbs";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DbsDetail",
  components: {
    TemplateDbsDetail,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const park = computed(() => store.getters["dbs/park"]);

    const isReadyToDraw = ref(false);

    onMounted(async () => {
      // 経路検索タブから直接このページを開かれた場合や利用/予約画面から戻った場合、storeにポート情報を持ってない為
      // ネイティブコール(ncPageReady) → jcSetDbsShareInfo → API.getDbsPark(条件による) のプロセスを踏む必要あり
      if (park.value == null) {
        // 開発ブラウザではMixwayAPIでロケーション情報取得
        if (store.getters["common/device"] == "BROWSER") {
          await dbsService.getDBSCyclePortInfoFromMixway();
        } else {
          // ページ描画完了をマップWebviewへ知らせる関数
          nativeHandlerService.ncPageReady();
        }
      } else {
        await isDBS();
        isReadyToDraw.value = true;
      }
    });

    // CorporationがドコモバイクシェアかつRegionが東京or横浜の場合は追加でAPIを叩く必要あり
    const isDBS = async () => {
      if (park.value.Corporation.code == "DOCOMO") {
        await API.getDbsPark(park.value.Station.code.split(".")[1]);
      }
    };

    // ネイティブからjcSetDbsShareInfoが叩かれたことを検知するには
    // parkの中身が変わったかを基準にするしかない
    watch(
      () => park.value,
      async (newPark, oldPark) => {
        if (oldPark == null || newPark.Station.Name != oldPark.Station.Name) {
          await isDBS();
        }
        isReadyToDraw.value = true;
      }
    );

    return {
      park,
      isReadyToDraw,
    };
  },
};
</script>
